import React, { useRef, useEffect, useState } from 'react';
import Navbar from './layout/Navbar';
//import MenuPage from './views/menu/MenuPage';
// import MiniCarta from './views/menu/components/MiniCarta';
// import Carta from './views/menu/components/Carta';
import CartaResto from './views/menu/components/CartaResto';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

const App = () => {
  const [navHeight, setNavHeight] = useState(0);
  const navRef = useRef(null);
  useEffect(() => {
    if (navRef.current) {
      setNavHeight(navRef.current.clientHeight);
    }
  }, [navRef]);
  return (
    <>
      <Router>
        <Navbar ref={navRef} />
        <div style={{ marginTop: navHeight }}>
          <Switch>
            {/* <Route path="/mini-carta" exact component={MiniCarta} />
            <Route path="/carta" exact component={CartaResto} />
            <Route path="/menu-beer" exact component={Carta} /> */}
            <Route path="/menu-resto" exact component={CartaResto} />
            <Redirect from="*" to="/menu-resto" />
          </Switch>
        </div>
      </Router>
    </>
  );
};

export default App;
